module.exports = __webpack_public_path__ + "img/ic_homestay_apply_item_img3.a9143c08.png";